import CheckNewOrders from "../symbols/checkNewOrdersPending";
import { HttpRequestPost } from "../../service";

const checkNewOrdersPendingAction = () => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_PENDING,
});
const checkNewOrdersPendingSuccessAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_PENDING_SUCCESS,
  payload: data,
});
const checkNewOrdersPendingFailureAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_PENDING_FAILURE,
  payload: data,
});
const checkNewOrdersPendingRefreshTimeStampAction = () => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_PENDING_REFRESH_TIME_STAMP,
});
const clearCheckNewOrdersPendingAction = () => ({
  type: CheckNewOrders.CLEAR_CHECK_NEW_ORDERS_PENDING,
});
export function getCheckNewOrdersPending(
  Date: string,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    dispatch(checkNewOrdersPendingAction());
    HttpRequestPost(
      "/order/check-new/pending",
      dispatch,
      checkNewOrdersPendingSuccessAction,
      checkNewOrdersPendingFailureAction,
      true,
      { Date: Date },
      callback
    );
  };
}

export function clearCheckNewOrdersPending() {
  return (dispatch: any) => {
    dispatch(clearCheckNewOrdersPendingAction());
  };
}
export function refreshTimeStampForCheckNewPending() {
  return (dispatch: any) => {
    dispatch(checkNewOrdersPendingRefreshTimeStampAction());
  };
}
